<script>
import { mapGetters } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    emptyStateMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'notifications/getUIFlags',
    }),
    emptyTitle() {
      return this.$t('INBOX.LIST.EMPTY_STATE_TITLE');
    },
    emptyMessage() {
      if (this.emptyStateMessage) {
        return this.emptyStateMessage;
      }
      return this.$t('INBOX.LIST.EMPTY_STATE_SUBTITLE');
    },
  },
};
</script>

<template>
  <div
    class="items-center justify-center hidden w-full h-full px-6 text-center lg:flex"
  >
    <div v-if="uiFlags.isFetching" class="flex justify-center my-4">
      <Spinner class="text-n-brand" />
    </div>
    <div
      v-else
      class="relative flex flex-col items-center w-full max-w-[420px] gap-3 px-8 py-9 overflow-hidden rounded-lg border border-[#2563EB]/15 bg-white shadow-lg shadow-blue-950/5 dark:border-[#2563EB]/20 dark:bg-[#0B1220] dark:shadow-[0_24px_70px_rgba(0,0,0,0.34)]"
    >
      <div
        class="absolute inset-x-10 top-0 h-px bg-[#2563EB]/55 dark:bg-[#D9FF00]/55"
      />
      <div
        class="grid place-content-center size-12 rounded-lg border border-[#2563EB]/20 bg-[#2563EB]/10 dark:border-[#2563EB]/28 dark:bg-[#2563EB]/14"
      >
        <fluent-icon icon="mail-inbox" size="28" class="text-[#2563EB] dark:text-white" />
      </div>
      <span class="text-base font-semibold text-n-slate-12 dark:text-white">
        {{ emptyTitle }}
      </span>
      <span class="max-w-[320px] text-sm leading-5 text-n-slate-11 dark:text-slate-300">
        {{ emptyMessage }}
      </span>
    </div>
  </div>
</template>
